import { IElementType, IElementTypeHint } from "@faro-lotv/ielement-types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCapturedData } from "@store/captured-data/captured-data-utils";
/**
 * Fetches the 360 photos of the project and the areas they are in, from the Project API.
 *
 * The lightweight structure has the whole tree in a few requests, but leaves out the trajectory
 * photos, so those are fetched on their own.
 * @throws {ApiResponseError} if the Project API client request fails
 */
export const fetchCapturedData = createAsyncThunk("capturedData/fetchCapturedData", async ({
  projectApiClient
}, {
  signal
}) => {
  const [structure, trajectoryImages] = await Promise.all([projectApiClient.getLightweightProjectStructure({
    signal
  }), projectApiClient.getAllIElements({
    types: [IElementType.img360],
    typeHints: [IElementTypeHint.odometryPath],
    signal
  })]);
  return getCapturedData(structure, trajectoryImages);
});